exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1rDnH tbody tr td,._1rDnH thead tr th{text-align:right}", ""]);

// exports
exports.locals = {
	"employeeBalanceTable": "_1rDnH"
};